module.exports = __webpack_public_path__ + "img/icon-map-pre.ad111348.svg";